package com.tfc.care.tfccare.di

import com.russhwolf.settings.Settings
import com.russhwolf.settings.StorageSettings
import com.tfc.care.tfccare.WebStaffFirebaseService
import com.tfc.care.tfccare.domain.repository.AppSettings
import com.tfc.care.tfccare.domain.repository.StaffFirebaseService
import org.koin.core.module.Module
import org.koin.dsl.module

actual val platformModule: Module
    get() = module {
        single<StaffFirebaseService> { WebStaffFirebaseService() }
        single<Settings> { StorageSettings() }
        single { AppSettings(get()) }
    }